import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input'];

  search() {
    const filter = this.inputTarget.value.toLowerCase()
    const blockType = this.data.get('blockType') || 'block'
    this.itemTargets = this.element.querySelectorAll('[data-simple-search-target="item"]')
    this.itemTargets.forEach((item) => {
      const filterData = item.getAttribute('data-filter-with')
      if (filterData) {
        item.style.display = filterData.toLowerCase().includes(filter)
          ? blockType
          : 'none'
      } else {
        console.warn(`Element ${item} does not have "data-filter-with" attribute.`)
      }
    })
  }
}
